<div class="selectContainer">
  <div class="slInputWrap">
    @if (showUnequalOption) {
      <div class="dropdownEqualOperator">
        <his-search-select-operator
          [widget]="widget"
          [isFirstInputElement]="isFirstInputElement">
        </his-search-select-operator>
      </div>
    }

    @if (showAutocomplete) {
      <his-search-select-autocomplete
        [hisDdKey]="widget.label"
        [hisDdSearchCriterion]="true"
        [uid]="uid"
        [removeSelectedOptionsFromDropdown]="removeSelectedOptionsFromDropdown"
        [selectedOptions]="selectedOptions"
        [searchEntity]="searchEntity"
        [searchConfigFile]="searchConfigFile"
        [minLength]="minLength"
        [limit]="limit"
        [showDropdownIcon]="showDropdownIcon"
        [isFirstInputElement]="isFirstInputElement && !showUnequalOption"
        (selected)="addSelectedElement($event)">
      </his-search-select-autocomplete>
    }
  </div>

  <his-search-select-popup
    [searchConfigFile]="searchConfigFile"
    [selectedOptions]="selectedOptions"
    [selectedOptionsIdColumn]="selectedOptionsIdColumn"
    [selectedOptionsLabelColumn]="selectedOptionsLabelColumn"
    [selectItemsButtonLabel]="selectItemsButtonLabel"
    [changeSelectedItemsButtonLabel]="changeSelectedItemsButtonLabel"
    [resultRowsPerPage]="resultRowsPerPage"
    [selectionSetting]="selectionSetting"
    [presetInputFields]="presetInputFields"
    [isFirstInputElement]="isFirstInputElement && !showUnequalOption && !showAutocomplete"
    (selectedOptionsChange)="selectedOptionsChange($event)"
    [showTableFilter]="showTableFilter">
  </his-search-select-popup>
  <div class="unsichtbar">{{'common.components.selectManyPicklist.selected' | hisUi}}:</div>
  <ng-container class="selectedOptionsList">
    @if (selectedOptions.length > 0) {
      <p-dataView [value]="selectedOptions" styleClass="selectedDataContainer" [emptyMessage]="'&nbsp;'">
        <ng-template let-selectedOptions #list>
          <div class="p-grid p-grid-nogutter">
            <ul>
              @for (selectedOption of selectedOptions; track selectedOption; let first = $first; let index = $index) {
              	@if (!maxDisplayedSelections || showAllSelected || index < maxDisplayedSelections-1 || maxDisplayedSelections === selectedOptions.length) {
                  <li class="selectedDataRow">
                    {{selectedOption.label}}
                    <button type="submit" (click)="$event.stopPropagation(); deleteSelectedOption(selectedOption);" hisImage="PANEL_CLOSE" class="icon deleteSelectedOption" title="{{selectedOption.label}}: {{'view.controls.disconnect' | hisUi}}"></button>
                  </li>
              	}
              }
              @if (maxDisplayedSelections && maxDisplayedSelections < selectedOptions.length) {
                @if (!showAllSelected) {
                  <li
                    class="selectedDataRow">
                    <button type="submit"
                      (click)="$event.stopPropagation(); toggleShowAllSelected(); $event.preventDefault();"
                      class="transparent showAllSelectedOptionsButton"
                      title="{{'common.components.selectManyPicklist.showAllSelected' | hisUi}}">
                      <span class="btnText">... {{selectedOptions.length - maxDisplayedSelections + 1}} {{'common.components.selectManyPicklist.more' | hisUi}}</span>
                      <img hisImage="ARROW_OUT"
                        class="inlineicon"
                        [title]="'common.components.selectManyPicklist.showAllSelected'| hisUi">
                    </button>
                  </li>
                }
                @if (showAllSelected) {
                  <li
                    class="selectedDataRow">
                    <button type="submit"
                      (click)="$event.stopPropagation(); toggleShowAllSelected(); $event.preventDefault();"
                      class="transparent showAllSelectedOptionsButton"
                      title="{{'common.components.selectManyPicklist.showLess' | hisUi}}">
                      <span class="btnText">{{'common.components.selectManyPicklist.showLess' | hisUi}}</span>
                      <img hisImage="ARROW_IN"
                        class="inlineicon"
                        [title]="'common.components.selectManyPicklist.showLess'| hisUi">
                    </button>
                  </li>
                }
              }
            </ul>
          </div>
        </ng-template>
      </p-dataView>
    }
  </ng-container>

</div>
